import React from 'react';
import { volumes } from '../data/salesCopy';
export function ValueStack() {
  return <section className="w-full border-b border-line bg-paper" data-id="element-256" data-mp="247un7mf83gql">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-5 sm:py-16 lg:py-20" data-id="element-257" data-mp="2461b3rluc4b7">
        <div className="max-w-2xl" data-id="element-258" data-mp="1q9xl6ai02i4j">
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-rust sm:text-xs" data-id="element-259" data-mp="1u9yawrajufqw">
            The complete system: 6 volumes
          </p>
          <h2 className="mt-3 font-display text-2xl font-semibold leading-tight tracking-tight text-ink sm:mt-4 sm:text-4xl" data-id="element-260" data-mp="2i0u1jl39r4wk">
            What’s inside the six volumes
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-ink-soft sm:mt-4 sm:text-lg" data-id="element-261" data-mp="2965vhspvdj6p">
            Every page is a print-ready PDF designed to be taught the same day — no prep, no
            adaptation, no guesswork.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:mt-12 sm:gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-262" data-mp="30wk0ezfwnl68">
          {volumes.map(volume => <article key={volume.number} className="flex h-full flex-col rounded-2xl border border-line bg-surface p-5 sm:p-7" data-id="element-263" data-mp="1tel909kt4kgg">
              <div className="flex items-baseline justify-between gap-4" data-id="element-264" data-mp="2356ac4rv8332">
                <span className="text-[11px] font-semibold uppercase tracking-[0.14em] text-rust sm:text-xs" data-id="element-265" data-mp="23798xd7334je">
                  Volume {volume.number}
                </span>
                <span className="text-[11px] font-medium text-ink-muted sm:text-xs" data-id="element-266" data-mp="2c49rh37h28ex">
                  {volume.pages}
                </span>
              </div>
              <h3 className="mt-2 font-display text-lg font-semibold leading-tight text-ink sm:mt-3 sm:text-2xl" data-id="element-267" data-mp="2m4k5ur58tlvo">
                {volume.title}
              </h3>
              <p className="mt-3 text-[15px] leading-relaxed text-ink-soft sm:mt-4" data-id="element-268" data-mp="2h2uqizazmm1s">
                {volume.body}
              </p>
              <ul className="mt-auto flex flex-wrap gap-1.5 pt-5 sm:gap-2 sm:pt-6" data-id="element-269" data-mp="mrg1yltpqsnm">
                {volume.tags.map(tag => <li key={tag} className="rounded-full border border-line px-2.5 py-1 text-[11px] font-medium text-ink-muted sm:px-3 sm:text-xs" data-id="element-270" data-mp="2muh8pnlzeyyf">
                    {tag}
                  </li>)}
              </ul>
            </article>)}
        </div>
      </div>
    </section>;
}